import React, { Suspense } from 'react'
import lazy from './LazyWithRetry'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loged from './LogedRoutes'
import Login from '../../containers/login/Login'
import MobileLayout from '@/components/layout/MobileLayout'
import GlobalLoader from '../../components/loading/GlobalLoader'

const ConfirmRegistration = lazy(() => import('../../containers/pages/userregistration/ConfirmRegistration'))
const CtmOpportunityActionPage = lazy(
  () => import('../../containers/pages/actions/customer/opportunity/CtmOpportunityActionPage'),
)
const CtmProjectActionPage = lazy(() => import('../../containers/pages/actions/customer/project/CtmProjectActionPage'))
const EntProjectActionPage = lazy(() => import('../../containers/pages/actions/enterprise/EntProjectActionPage'))
const GenericSuccess = lazy(() => import('@/components/success/GenericSuccess'))
const StatusPage = lazy(() => import('@/components/utils/StatusPage'))

const NotLoged = ({ standard = true }) => {
  return (
    <Suspense fallback={<GlobalLoader forceOpen={true} />}>
      <Routes>
        {/* Aqui hay muchas rutas duplicadas en loged y notloged, lo suyo seria que no estuvieran duplicadas, y estuvieran separadas por Mobile y desktop (para los layout y tambien para evitar duplicidades) */}
        <Route element={<MobileLayout standard={standard} />}>
          <Route path="/oa/:code" element={<CtmOpportunityActionPage />} />
          <Route path="/ca/:code" element={<CtmProjectActionPage />} />
          <Route path="/success" element={<GenericSuccess />} />
          <Route path="/entactions/:code" element={<EntProjectActionPage />} />
          <Route path="/confirm/:code" element={<ConfirmRegistration />} />
          <Route path="/status" element={<StatusPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/" element={<Login standard={standard} />} />
        <Route path="/home" element={<Login standard={standard} />} />
      </Routes>
    </Suspense>
  )
}

const RoutesComponent = ({ standard = true }) => {
  const user = useSelector(({ login }) => login)
  return <>{user.iduser ? <Loged standard={standard} /> : <NotLoged standard={standard} />}</>
}

export default RoutesComponent
